import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ReactNode } from 'react';
import { View } from 'react-native';

/** A labelled row of toolbar options. */
export const ToolbarRow = ({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) => {
  const { rpx } = useResponsiveContext();
  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: rpx(6),
      }}
    >
      <Typography.Text
        size={rpx(12)}
        color={aiColors.mutedForeground}
        style={{ width: rpx(32) }}
      >
        {label}
      </Typography.Text>
      {children}
    </View>
  );
};
